import { render, staticRenderFns } from "./DrawingConfig.vue?vue&type=template&id=74a845f9"
import script from "./DrawingConfig.vue?vue&type=script&lang=js"
export * from "./DrawingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a845f9')) {
      api.createRecord('74a845f9', component.options)
    } else {
      api.reload('74a845f9', component.options)
    }
    module.hot.accept("./DrawingConfig.vue?vue&type=template&id=74a845f9", function () {
      api.rerender('74a845f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/DrawingConfig.vue"
export default component.exports